import React, { useRef } from "react";
import { exportSnapshotPdf } from "../utils/exportSnapshotPdf";
//import React, { useMemo, useState } from "react";
import TaskCard from "./TaskCard";

//export default function SnapshotReportView({ report, snapshotDate }: any) {
export default function SnapshotReportView({
    report,
    snapshotDate,
    projectName
}: any) {

  const reportRef = useRef<HTMLDivElement>(null);
  
  if (!report) return null;

  const tasks = report.tasks || [];

 /*  const [taskGroup, setTaskGroup] = useState("");

const taskGroups = useMemo(() => {
  const groups: any[] = [];

  tasks.forEach((t: any) => {
    if (
      t.taskGroupNo &&
      !groups.some((g) => g.taskGroupNo === t.taskGroupNo)
    ) {
      groups.push({
        taskGroupNo: t.taskGroupNo,
        taskGroupName: t.taskGroupName,
      });
    }
  });

  return groups.sort((a, b) =>
    a.taskGroupName.localeCompare(b.taskGroupName)
  );
}, [tasks]); 

const filterTasks = (items: any[]) => {
  if (!taskGroup) return items;

  return items.filter(
    (t: any) => String(t.taskGroupNo) === taskGroup
  );
};
 */
  const toDate = new Date(snapshotDate);

  // Use backend overdue calculation
  const overdue = report.overdueSnags || [];

 // const overdue = filterTasks(report.overdueSnags || []);

  // Safer closed check
  const isClosed = (t: any) =>
    t.taskType?.toLowerCase() === "closed";

  // Late Start
  /*const lateStart = tasks.filter(
    (t: any) =>
      t.startDate && new Date(t.startDate) > toDate
  );*/
const lateStart = report.lateStart || [];

//const lateStart = filterTasks(report.lateStart || []);
  

  // On Progress
   const onProgress = tasks.filter(
    (t: any) =>
      t.progress > 0 && !isClosed(t)
  ); 
  
 const onHold = report.onHold || [];

  const handleDownloadPdf = async () => {
  if (!reportRef.current) return;

  await exportSnapshotPdf(
    reportRef.current,
   
      projectName,
     snapshotDate
  );
}; 

/* const handleDownloadPdf = async () => {
  if (!report) return;

  await exportSnapshotPdf(report, projectName, snapshotDate);
}; */




 /*  return (
    <div className="space-y-10 p-4"> */
    return (
  <>
    <div className="flex justify-end mb-4">
      <button
        onClick={handleDownloadPdf}
        className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
      >
        Download PDF
      </button>
    </div>

    <div
      ref={reportRef}
     // className="space-y-10 p-4 bg-white"
       className="space-y-10 p-4 bg-white pb-32"
    >

       {/* PDF Header */}
  {/* PDF Header */}
<div className="mb-6 border-b pb-4">
  <h1 className="text-2xl font-bold text-gray-800">
    {projectName} Snapshot Report as of{" "}
    {new Date(snapshotDate).toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    })}
  </h1>
</div>

      {/* SUMMARY */}

     
      {/* <section> */}
      <section className="pb-20">


        <h2 className="text-xl font-semibold mb-3">
          Snapshot Summary
        </h2>

        <div className="grid grid-cols-3 gap-4 text-center">

          <div className="p-4 border rounded bg-gray-50">
            <div className="text-gray-500 text-sm">
              Total Snags
            </div>
            <div className="text-2xl font-bold">
              {report.totalSnags}
            </div>
          </div>

          <div className="p-4 border rounded bg-green-100">
            <div className="text-gray-500 text-sm">
              Closed Till Date
            </div>
            <div className="text-2xl font-bold">
              {report.closedTillTo}
            </div>
          </div>

          <div className="p-4 border rounded bg-red-100">
            <div className="text-gray-500 text-sm">
              Open Snags
            </div>
            <div className="text-2xl font-bold">
              {report.openSnags}
            </div>
          </div>

        </div>
      </section>


      {/* OVERDUE */}
      <section>
        <h2 className="text-xl font-semibold mb-2">
          Overdue Snags ({overdue.length})
        </h2>

        {overdue.length === 0 && (
          <p className="text-gray-500 text-sm">
            No overdue snags
          </p>
        )}

        {overdue.map((t: any) => (
          <TaskCard key={t.taskNo} t={t} />
        ))}
      </section>


      {/* LATE START */}
      <section>
        <h2 className="text-xl font-semibold mb-2">
          Late Start ({lateStart.length})
        </h2>

        {lateStart.length === 0 && (
          <p className="text-gray-500 text-sm">
            No late start tasks
          </p>
        )}

        {lateStart.map((t: any) => (
          <TaskCard key={t.taskNo} t={t} />
        ))}
      </section>


      {/* ON PROGRESS */}
      <section>
        <h2 className="text-xl font-semibold mb-2">
          On Progress ({onProgress.length})
        </h2>

        {onProgress.length === 0 && (
          <p className="text-gray-500 text-sm">
            No tasks in progress
          </p>
        )}

        {onProgress.map((t: any) => (
          <TaskCard key={t.taskNo} t={t} />
        ))}
      </section>

      {/* TASKS ON HOLD */}
<section>
  <h2 className="text-xl font-semibold mb-2">
    Tasks On Hold ({onHold.length})
  </h2>

  {onHold.length === 0 && (
    <p className="text-gray-500 text-sm">
      No tasks on hold
    </p>
  )}

  {onHold.map((t: any) => (
    <TaskCard key={t.taskNo} t={t} />
  ))}
</section>

    </div>
     </>
  );
} 